import { Container } from "../components/ui";
import { Button } from "../ds/core";
import { useLocale } from "../i18n/useLocale";

/**
 * NotFound — custom 404 page (catch-all route). Keeps the shared shell
 * (nav + footer) and offers a couple of helpful links back into the site.
 */
export default function NotFound() {
  const { t } = useLocale();
  return (
    <section className="bg-bg font-ds">
      <Container className="flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <p className="text-ds-14 font-semibold uppercase tracking-[0.14em] text-ink-faint">{t("common:notFound.eyebrow")}</p>
        <h1 className="mt-3 text-ds-38 font-semibold leading-[1.06] tracking-[-1px] text-ds-ink sm:text-ds-46">
          {t("common:notFound.title")}
        </h1>
        <p className="mt-4 max-w-md text-ds-18 leading-relaxed text-ds-ink-soft">
          {t("common:notFound.body")}
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Button to="/" variant="solid">{t("common:notFound.backHome")}</Button>
          <Button to="/features" variant="outline">{t("common:notFound.exploreFeatures")}</Button>
        </div>
      </Container>
    </section>
  );
}
